import { useLoggedInUser } from '../../../app/hooks/useLoggedInUser'
import { useGetProductQuery } from '../../../app/redux-fetch/apiProducts'
import SpinnerModalBlock from '../../../components/Spinner/SpinnerModalBlock'
import { createInitialProduct } from '../utils'
import ProductForm from './ProductForm/ProductForm'
import { ProductSchemaType } from './ProductForm/productValidationSchema'

type ProductModalProps = {
  productId: number
  customerId: number
  isDisabled?: boolean
}

const ProductModal = ({ productId, customerId, isDisabled }: ProductModalProps) => {
  const { tenantId } = useLoggedInUser()
  const { data, isSuccess } = useGetProductQuery({ tenantId, customerId, productId })

  if (!isSuccess) return <SpinnerModalBlock />

  const productData: ProductSchemaType = data
    ? {
      ...data,
      customerId: data.customerId ?? customerId,
      enabled: data.enabled ?? false,
      name: data.name ?? '',
      productCategoryId: data.productCategoryId ?? 0,
      countryOfOriginId: data.countryOfOriginId ?? 0,
      sku: data.sku ?? '',
      inventoryUnitId: data.inventoryUnitId ?? 0,
      documents: (data.documents || []).map((doc) => ({
        id: doc.id,
        name: doc.name || '',
        expiryDate: doc.expiryDate || new Date(),
        documentTypeId: doc.documentTypeId,
        fileId: doc.fileId,
      })),
      physicalProperties: {
        ...data.physicalProperties,
        volume: data.physicalProperties?.volume ?? undefined,
        length: data.physicalProperties?.length ?? undefined,
        width: data.physicalProperties?.width ?? undefined,
        height: data.physicalProperties?.height ?? undefined,
        lengthMeasureUnitId: data.physicalProperties?.lengthMeasureUnitId ?? -1,
        weightMeasureUnitId: data.physicalProperties?.weightMeasureUnitId ?? -1,
        volumeMeasureUnitId: data.physicalProperties?.volumeMeasureUnitId ?? -1,
        densityMeasureUnitId: data.physicalProperties?.densityMeasureUnitId ?? -1,
        isRectangular: data.physicalProperties?.isRectangular ?? true,
        netWeight: data.physicalProperties?.netWeight ?? undefined,
        grossWeight: data.physicalProperties?.grossWeight ?? undefined,
        density: data.physicalProperties?.density ?? undefined,
        maxLoadingHeight: data.physicalProperties?.maxLoadingHeight ?? undefined,
      },
      ...(data.temperatureSetting ? { temperatureSetting: data.temperatureSetting } : {}),
      prices: (data.prices || []).map((price) => ({
        ...price,
        priceValidFrom: price.priceValidFrom || new Date().toString(),
        priceValidTo: price.priceValidTo || null,
        validFrom: price.validFrom || new Date().toISOString(),
        validTo: price.validTo || null,
        documents: (price.documents || []).map((doc) => ({
          id: doc.id,
          name: doc.name || '',
          expiryDate: doc.expiryDate || new Date(),
          documentTypeId: doc.documentTypeId,
          fileId: doc.fileId,
        })),
      })),
    }
    : createInitialProduct(customerId)

  return <ProductForm product={productData} isDisabled={isDisabled ?? false} />
}

export default ProductModal
